<template>
    <org-unit-details :orgUnitId="props.orgUnitId">
        <div>
            <group-collections-list :orgUnitId="props.orgUnitId"></group-collections-list>
        </div>
    </org-unit-details>
</template>

<script setup>
import OrgUnitDetails from '../OrgUnitDetails.vue';
import GroupCollectionsList from '../../../group-collections/list/GroupCollectionsList.vue';

const props = defineProps({
    orgUnitId: {
        type: Number,
        required: true,
    },
});
</script>
